import { defineComponent as _defineComponent } from 'vue'
import { computed, watch, reactive, ref, provide, nextTick } from 'vue';
import CButton from '@/components/shared/CButton';
import type { CanvasEx } from '@/typings/canvas';
import type { ActiveSelection, ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import type { ImageEffectType } from '@/typings/customilyElements/imageEffectType';
import ImageEffectsPropertiesList from '@/components/DesignStudio/ImageEffectsProperties/components/list/ImageEffectsPropertiesList.vue';
import ImageEffectsPropertiesCreate from '@/components/DesignStudio/ImageEffectsProperties/components/create/ImageEffectsPropertiesCreate.vue';
import store from '@/store';

interface Props {
    canvas: CanvasEx;
    imageElement: ImagePlaceholderElement;
    editMode?: boolean;
    selectedGroup?: ActiveSelection<ImagePlaceholderElement>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsProperties',
  props: {
    canvas: null,
    imageElement: null,
    editMode: { type: Boolean },
    selectedGroup: null
  },
  setup(__props: any) {

const props = __props as {
    canvas: CanvasEx;
    imageElement: ImagePlaceholderElement;
    editMode?: boolean;
    selectedGroup?: ActiveSelection<ImagePlaceholderElement>;
};



const model = reactive({
    imageEffects: props.imageElement?.imageEffects || []
});

// Provide: id del efecto a abrir (último agregado)
const openEffectId = ref<string | null>(null);
provide('openEffectId', openEffectId);

const isDisabled = computed(() => props.imageElement?.locked);
const hasEffects = computed(() => model.imageEffects && model.imageEffects.length > 0);
const imageEffect = computed(() => store.state.imageEffectsProperties?.imageEffect);
const showMixed = ref(!!props.imageElement?.containsImageEffects && !props.imageElement?.imageEffects);

const updateImageEffects = () => {
    if (!props.imageElement || isDisabled.value) return;
    const objectsToEdit = props.selectedGroup ? props.selectedGroup?.getObjects() : [props.imageElement];
    for (const object of objectsToEdit) {
        object.set('imageEffects', model.imageEffects);

        if (props.editMode) {
            object.setEditedProp('imageEffects');
        }
    }
    showMixed.value = false;
    props.canvas.requestRenderAll();
};

const openAddEffectModal = () => {
    store?.dispatch('imageEffectsProperties/openAddModal');
};

const removeImageEffect = (effect: ImageEffectType) => {
    if (!model.imageEffects || isDisabled.value) return;

    const effectId = effect.id;
    const index = model.imageEffects.findIndex((e) => e.id === effectId);

    if (index !== -1) {
        model.imageEffects.splice(index, 1);
        updateImageEffects();
    }
};

const updateImageEffect = async (effect: ImageEffectType, newData?: ImageEffectType | undefined) => {
    if (!model.imageEffects || isDisabled.value) return;

    const effectId = effect.id;
    await nextTick();
    const index = model.imageEffects.findIndex((e) => e.id === effectId);
    if (index !== -1) {
        model.imageEffects[index] = newData ? { ...effect, ...newData } : effect;
        model.imageEffects = [...model.imageEffects];
        updateImageEffects();
        store.dispatch('imageEffectsProperties/closeAddModal');
    }
};

const handleReorder = (newEffects: ImageEffectType[]) => {
    if (!model.imageEffects || isDisabled.value) return;

    model.imageEffects = newEffects;
    updateImageEffects();
};

watch(
    () => props.imageElement?.imageEffects,
    () => {
        if (props.imageElement?.imageEffects) {
            model.imageEffects = [...props.imageElement.imageEffects];
        } else {
            model.imageEffects = [];
        }
        showMixed.value = !!props.imageElement?.containsImageEffects && !props.imageElement?.imageEffects;
    },
    { deep: true }
);

watch(
    () => imageEffect.value,
    async (value) => {
        if (value) {
            model.imageEffects.push(value);
        }
    }
);

return { __sfc: true,props, model, openEffectId, isDisabled, hasEffects, imageEffect, showMixed, updateImageEffects, openAddEffectModal, removeImageEffect, updateImageEffect, handleReorder, CButton, ImageEffectsPropertiesList, ImageEffectsPropertiesCreate }
}

})